import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { ComponentMessageDispatcher } from '../../../core/service/component-message-dispather.service';
import { MessageService } from '../../../core/service/message.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { EmailStatus } from '../../model/const/enums';
import { FormControlEx } from '../../../core/component/forms/form-control';
import { EmailService } from '../../service/data/email.service';
import { Email } from '../../model/email';
import { ActivatedRoute } from '@angular/router';
import { standardCommand } from '../../../core/model/command';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';

@Component({
    selector: 'app-send-single-new-email',
    templateUrl: './send-single-new-email-form.component.html',
    styleUrls: ['./send-single-new-email-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SendSingleNewEmailFormComponent extends FormComponentBase<Email> {
  constructor(
    private _messageDispather: ComponentMessageDispatcher,
    private _nativeWindow: NativeWindowService,
    activatedRoute: ActivatedRoute,
    dispatcher: CommandDispatcher,
    protected fb: FormBuilder,
    protected fc: FormControlExFactory,
    handlerResolver: CommandHandlerResolver,
    protected service: EmailService,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, service, messageService, navigation, dispatcher, handlerResolver);
    this.addMenuItemDefinition('CREATE_BTN', standardCommand.create);
  }

  get canSend(): boolean {
    return this.form && this.form.valid;
  }
  get showSend(): boolean {
    return this.dataContext && this.dataContext.status === EmailStatus.Created;
  }

  protected createModel(): Email {
    return new Email();
  }

  protected getFormGroup(): FormGroup {
    return this.fb.group({
      recipientEmailAddress: this.fc.createMandatory('COMMON.EMAIL_ADDRESS', this.dataContext.recipientEmailAddress),
      subject: this.fc.createMandatory('MAIL_FORM.HEADER_LABEL', this.dataContext.subject),
      body: this.fc.createMandatory('MAIL_FORM.BODY_SMS_LABEL', this.dataContext.body),
    });
  }

  private _getFormData() {
    let data = this.form.value;
    return data;
  }

  protected init(emailMessage: Email) {
    super.init(emailMessage);
  }

  cancel() {
    this.navigation.navigateBack();
  }

  send() {
    this.AddSubscription(
      this.service.sendNew(this._getFormData()).subscribe(
        () => {
          this.formSubmitted();
          this.messageService.showSuccess('SUCCESS.EMAIL_SENT');
        },
        error => this.messageService.showError(error)
      )
    );
  }
}
